import { LoaderService } from 'src/app/service/loader/loader.service';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
  QueryList,
  Renderer2,
  ViewChild,
  ViewChildren
} from '@angular/core';
import { FormControl, FormGroup, UntypedFormControl } from '@angular/forms';

import {
  catchError,
  debounceTime,
  map,
  merge,
  Observable,
  of as observableOf,
  of,
  ReplaySubject,
  startWith
} from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';

import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';

import { MatPaginator } from '@angular/material/paginator';
import { SharedModule } from 'src/app/core/shared/shared.module';
import {
  QueryParamsModel,
  QueryResultsModel,
  TableColumn
} from '../common-table/common-table.component';
import { AppSettingsService } from 'src/app/core/app-settings.service';
import { VexPageLayoutComponent } from '@vex/components/vex-page-layout/vex-page-layout.component';
import { VexPageLayoutHeaderDirective } from '@vex/components/vex-page-layout/vex-page-layout-header.directive';
import { VexBreadcrumbsComponent } from '@vex/components/vex-breadcrumbs/vex-breadcrumbs.component';
import { VexPageLayoutContentDirective } from '@vex/components/vex-page-layout/vex-page-layout-content.directive';
import { SelectionModel } from '@angular/cdk/collections';
import { MatSelectChange } from '@angular/material/select';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { FilterColumnsComponent } from '../filter-columns/filter-columns.component';
import { ViewPdfComponent } from 'src/app/pages/master-data/program-config/components/view-pdf/view-pdf.component';
import { CommonAutocompleteComponent } from '../common-autocomplete/common-autocomplete.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { brands } from 'src/app/pages/list-configuration/column-configuration-list/components/list-configuration-filter';
import { UserAuthenticationService } from 'src/app/core/navigation/user-authentication.service';
import { CommonModule } from '@angular/common';
import { ViewAttachmentsService } from 'src/app/core/shared/services/view-attachments.service';
import { CustomScrollbarService } from 'src/app/core/shared/services/custom-scroll-bar.service';
import { VexScrollbarComponent } from '../../../../@vex/components/vex-scrollbar/vex-scrollbar.component';

@Component({
  selector: 'vex-multiple-row-common-table',
  standalone: true,
  imports: [
    CommonModule,
    SharedModule,
    VexPageLayoutComponent,
    VexBreadcrumbsComponent,
    VexPageLayoutContentDirective,
    CommonAutocompleteComponent,
    VexScrollbarComponent
  ],
  templateUrl: './multiple-row-common-table.component.html',
  styleUrls: ['./multiple-row-common-table.component.scss']
})
export class MultipleRowCommonTableComponent {
  @ViewChild('paginator', { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChildren('innerSort') innerSort: QueryList<MatSort>;
  @ViewChildren('innerTables') innerTables: QueryList<MatTable<any>>;

  pageIndex = 0;
  pageSize = 50;
  pageSizeOptions: number[] = [50, 100, 150, 200];
  @Input() title = '';
  @Input() columns: TableColumn<any>[] = [];
  @Input() innerColumns: TableColumn<any>[] = [];
  @Input() actions: Array<any> = [];
  @Input() innerActions: Array<any> = [];
  @Input() burgerActions: Array<any> = [];
  @Input() burgerInnerActions: Array<any> = [];

  @Input() tableConfig = {
    showSearch: true,
    showPagination: true,
    actionFields: true,
    showDateRange: false,
    showDateFilter: false,
    showStaffFilter: false,
    showOrderTypeFilter: false,
    showPlatformFilter: false,
    isAddButton: false,
    isExportButton: false
  };
  @Output() onLoadItemsEvent = new EventEmitter();
  @Output() onActionClickEmit = new EventEmitter();
  expandedElement: any;
  selectedItem: any;
  //public searchCtrl = new FormControl('');
  queryResults: QueryResultsModel;
  dataSource: MatTableDataSource<any>;
  public filteredAndPagedIssues: Observable<any[]> = of([]);

  @Input() showActiveInActive: boolean = false;
  @Input() showWidthFullWidth: boolean = true;
  @Input() showBreadCrumbs: boolean = true;
  @Input() enablePadding: boolean = true;
  @Input() showActiveArchiveList: boolean = false;
  @Input() enableInfoIcon: boolean = false;
  @Input() showCQACompanyList: boolean = false;
  @Input() toggleViewString: string = 'CQA';
  layoutCtrl = new FormControl('boxed');
  toggleCtrl = new FormControl('Active');
  toggleArchiveListCtrl = new FormControl('active');
  toggleCQACompanyListCtrl = new FormControl('cqa');
  @Input() crumbsMenu = '';
  public selection = new SelectionModel<any>(true, []);
  @Input() showFilterBtn = false;
  @Input() filterDropdown: boolean = false;

  @Output() onActiveInactive = new EventEmitter();
  @Output() onActiveArchiveList = new EventEmitter();
  @Output() onCQACompanyList = new EventEmitter();
  deleteIcon: boolean;
  infoIcon: boolean;
  filterButtonText = 'Filter';
  filterButtonIcon = 'mat:filter_alt';
  showFilter = false;
  @Input() sampleTypeList: any[] = [];
  @Input() showSampleTypeFilter: boolean = false;
  @Input() programList: any[] = [];
  @Input() showProgramFilter: boolean = false;
  @Output() onChangeProgram = new EventEmitter();

  @Input() statusList: any[] = [
    { name: 'Pending', value: 'Pending' },
    { name: 'On Hold', value: 'on-hold' },
    { name: 'Completed', value: 'completed' }
  ];
  @Input() paymentStatusList: any[] = [
    { name: 'Initiated', value: 'PaymentInitiated' },
    { name: 'Completed', value: 'PaymentCompleted' }
  ];
  @Input() paymentMethodList: any[] = [
    { name: 'Card', value: 'card' },
    { name: 'ACH', value: 'ach' },
    { name: 'Wire Transfer', value: 'wire-transfer' }
  ];
  @Input() showStatusFilter: boolean = false;
  @Output() onChangeSampleStatus = new EventEmitter();
  @Input() showPaymentStatusFilter: boolean = false;
  @Output() onChangePaymentStatus = new EventEmitter();
  @Input() showPaymentMethodStatusFilter: boolean = false;
  @Output() onChangePaymentMethodStatus = new EventEmitter();

  @Input() companyList: any[] = [];
  @Input() showCompanyFilter: boolean = false;
  @Output() onChangeCompany = new EventEmitter();
  public datePickerForm: FormGroup;

  @Input() showAddButton = false;
  @Input() showExportButton = false;
  @Output() onExportClick = new EventEmitter();
  public activeRoute? = '';
  @Input() childActiveRoute: string = '';
  @Output() onAddClick = new EventEmitter();
  @Output() onChangeSampleType = new EventEmitter();
  @Output() onDateRangeChange = new EventEmitter();
  @Input() showDateRange: boolean = false;
  @Input() showSearchCtrl: boolean = true;
  @Input() showPagination: boolean = true;
  @Output() onAddOptionClick = new EventEmitter();
  @Input() showAddOptionButton = false;
  @Input() showAddOptionButtonValues: any[];
  @Input() showBrandToggleList: boolean = false;
  toggleBrandToggleListCtrl = new FormControl('brands');
  @Output() onBrandToggleList = new EventEmitter();
  @Input() isLoading: boolean = false;
  @Input() showStatusBadgeFilter: boolean = false;
  @Input() badgeFilterItems: any[] = [];
  activeItem: string | null = 'all';
  @Output() onBadgeFilterEmit = new EventEmitter();
  @Output() onBtnActionClick = new EventEmitter();

  private readonly destroyRef: DestroyRef = inject(DestroyRef);

  searchCtrl = new UntypedFormControl();
  userDetails: any;
  @Input() showReloadTableButton: boolean = true;
  @Output() onActionColumnClick = new EventEmitter();
  @ViewChild('scrollContent') scrollContent!: ElementRef;
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;
  @ViewChild('scrollBar') scrollBar!: ElementRef;

  @ViewChildren('rowElement', { read: ElementRef })
  rowElements!: QueryList<ElementRef>; // Access each row element
  @ViewChildren('cellElement', { read: ElementRef })
  cellElements!: QueryList<ElementRef>; // Access each cell element
  _isLoading$ = this.loaderService.isLoading$;

  constructor(
    private router: Router,
    public appSettingsService: AppSettingsService,
    public dialog: MatDialog,
    private _cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    public userCheck: UserAuthenticationService,
    private viewAttachmentsService: ViewAttachmentsService,
    private loaderService: LoaderService,
    private customScrollbarService: CustomScrollbarService,
    private renderer: Renderer2
  ) {}
  ngOnInit() {
    this.loaderService.hideLoader(true); // Hide Interceptor loader
    this.userDetails = this.appSettingsService.userData()?.userDetails;
    this.datePickerForm = new FormGroup({
      start: new FormControl(),
      end: new FormControl()
    });
    this.activeRoute = this.childActiveRoute
      ? this.childActiveRoute
      : this.router.url.split('/').pop();

    this.datePickerForm.valueChanges
      .pipe(debounceTime(200))
      .subscribe((event) => {
        if (event.start && event.end) {
          this.changeDate(event);
        } else if (!event.start && !event.end) {
          this.changeDate(null);
        }
      });

    this.toggleCtrl.valueChanges.subscribe((i) => {
      this.onActiveInactive.emit(i);
    });
    this.toggleArchiveListCtrl.valueChanges.subscribe((i) => {
      this.onActiveArchiveList.emit(i);
    });
    this.toggleCQACompanyListCtrl.valueChanges.subscribe((i) => {
      this.onCQACompanyList.emit(i);
    });
    this.toggleBrandToggleListCtrl.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((i) => {
        this.expandedElement = null;
        this.selectedItem = null;
        this.onBrandToggleList.emit(i);
        // this.router.navigate([], {
        //   queryParams: { active: i },
        //   queryParamsHandling: 'merge'
        // });
      });
    this.searchCtrl.valueChanges
      .pipe(debounceTime(20), takeUntilDestroyed(this.destroyRef))
      .subscribe((search) => {
        // this.router.navigate([], { queryParams: { search } });
        this.initLoadItems(false);
      });

    this.route.queryParams
      .pipe(debounceTime(20), takeUntilDestroyed(this.destroyRef))
      .subscribe((params) => {
        this.searchCtrl.reset('', { emitEvent: true });
      });
  }
  ngAfterViewInit() {
    this.initLoadItems();

    merge(this.paginator?.page)
      .pipe(startWith())
      .subscribe((resp) => {
        if (resp) {
          // if (!this.showActiveInActive) {
          //   this.initLoadItems();
          // }
          const pageIndex = this.paginator ? this.paginator.pageIndex : 0;
          // this.router.navigate([], {
          //   queryParams: { page: pageIndex + 1 },
          //   queryParamsHandling: 'merge'
          // });
          this.initLoadItems();
        }
      });

    setTimeout(() => {
      this.customScrollBar();
    }, 500);
  }
  get visibleColumns() {
    // let data = localStorage.getItem(this.router.url);
    // if (data) this.columns = JSON.parse(data);
    // const userHasPermission = this.navigationService.isHavePermission(
    //   this.activeRoute,
    //   ['Edit', 'View', 'Delete']
    // );
    // if (userHasPermission) {
    //   return this.columns
    //     .filter((column) => column.visible)
    //     .map((column) => column.property);
    // } else {
    //   // Exclude the "Actions" column if the user doesn't have permission
    //   return this.columns
    //     .filter((column) => column.visible && column.property !== 'actions')
    //     .map((column) => column.property);
    // }

    return this.columns
      .filter((column) => column.visible)
      .map((column) => column.property);
  }

  get innerColumn() {
    return this.innerColumns
      .filter((column) => column?.visible)
      .map((column) => column?.property);
  }

  public getDataByType(row: any, column: any) {
    let data = '';

    switch (column.type) {
      case 'money':
        if (row[column.property] !== '-') {
          data = '$' + row[column.property];
        } else {
          data = row[column.property];
        }
        break;
      case 'date':
        data = row[column.property];
        break;
      case 'price':
        data = this.formatCurrency(Number(row[column.property]));

        break;
      default:
        data =
          row[column.property] !== '' &&
          row[column.property] !== null &&
          row[column.property] !== undefined
            ? row[column.property]
            : '-';

        break;
    }
    return data;
  }
  toggleInnerTable(element: any): void {
    if (this.expandedElement === element) {
      // If the row is already expanded, close it
      this.expandedElement = null;

      this.selectedItem = null;
    } else {
      // Expand the row and set the selected item
      this.expandedElement = element;
      this.selectedItem = element;
      setTimeout(() => {
        this.onSetHeightInnerTableAction();
      }, 500);
    }
  }
  filterConfiguration(): any {
    const filter: any = {};
    return filter;
  }
  public subject$: ReplaySubject<QueryResultsModel> =
    new ReplaySubject<QueryResultsModel>();
  public data$: Observable<QueryResultsModel> = this.subject$.asObservable();

  initLoadItems(firstLoad: boolean = false) {
    const pageIndex = this.paginator ? this.paginator.pageIndex : 0;
    const pageSize = this.paginator ? this.paginator.pageSize : 0;
    const queryParams = new QueryParamsModel(
      this.filterConfiguration(),
      this.sort ? this.sort.direction.toUpperCase() : 'DESC',
      this.sort ? this.sort.active : 'id',
      pageIndex,
      firstLoad ? 50 : pageSize,
      this.searchCtrl ? this.searchCtrl.value : ''
    );
    let queryResults = {
      items: [],
      totalCount: 0,
      error: ''
    };
    this.dataSource = new MatTableDataSource(undefined);
    this.subject$.next(queryResults);
    this.isLoading = true;
    this.onLoadItemsEvent.emit(queryParams);
    this._cdr.detectChanges();
  }
  resultsLength: number;
  public loadItems(queryResults: QueryResultsModel) {
    this.queryResults = queryResults;
    this.resultsLength = queryResults.totalCount;
    this.dataSource = new MatTableDataSource(queryResults.items);
    this.subject$.next(queryResults);
    this.isLoading = false;
    this.loaderService.hide();
    this._cdr.detectChanges();
    this.onLoadGridColumns();
  }

  trackByProperty<T>(index: number, column: TableColumn<T>) {
    return column.property;
  }

  onOpenSortColumnTable() {
    let dialogRef: MatDialogRef<FilterColumnsComponent>;
    dialogRef = this.dialog.open(FilterColumnsComponent, {
      width: '40%',
      data: {
        columns:
          this.innerColumns.length > 0 ? this.innerColumns : this.columns,
        childActiveRoute: this.childActiveRoute
      }
    });

    dialogRef.afterClosed().subscribe((resp) => {
      this.onLoadGridColumns();
    });
  }
  onCreate() {
    this.onAddClick.emit();
  }

  toggleFilter() {
    this.showFilter = !this.showFilter;
    if (this.showFilter) {
      this.filterButtonText = 'Clear';
      this.filterButtonIcon = 'mat:close';
    } else {
      this.filterButtonIcon = 'mat:filter_alt';
      this.filterButtonText = 'Filter';
    }
    this.resetEventValues();
  }
  viewFileData(ev: any) {
    let dialogRef: MatDialogRef<ViewPdfComponent>;
    dialogRef = this.dialog.open(ViewPdfComponent, {
      width: '80%',
      data: {
        src: ev
      }
    });

    dialogRef.afterClosed().subscribe((resp) => {});
  }
  onViewFileData(title: any, url: any) {
    const fileExtension: string =
      this.viewAttachmentsService.getFileExtensionFromUrl(url);

    switch (fileExtension) {
      case 'xlsx':
      case 'xls':
        this.viewAttachmentsService.onViewExcel(url, title);
        break;

      case 'pdf':
        this.viewAttachmentsService.onViewPdf(url, title);
        break;

      case 'jpeg':
      case 'jpg':
      case 'png':
        this.viewAttachmentsService.onViewImage(url, title);
        break;

      default:
        this.viewAttachmentsService.onViewPdf(url, title);
        console.error('Unsupported file type:', fileExtension);
        break;
    }
  }
  changeSampleType(event: MatSelectChange) {
    this.onChangeSampleType.emit(event.value);
  }
  changeProgram(event: MatSelectChange) {
    this.onChangeProgram.emit(event.value);
  }

  resetEventValues() {
    this.onChangeSampleType.emit({ type: '' });
    this.onChangeProgram.emit({ type: '' });
    this.onChangeSampleStatus.emit({ type: '' });
    this.onChangePaymentMethodStatus.emit({ type: '' });
    this.onChangePaymentStatus.emit({ type: '' });
    this.onChangeCompany.emit({ type: '' });
    this.onDateRangeChange.emit({ type: '' });
  }

  changeSampleStatus(event: MatSelectChange) {
    this.onChangeSampleStatus.emit(event.value);
  }
  changePaymentMethod(event: MatSelectChange) {
    this.onChangePaymentMethodStatus.emit(event.value);
  }
  changePaymentStatus(event: MatSelectChange) {
    this.onChangePaymentStatus.emit(event.value);
  }
  changeCompany(event: MatAutocompleteSelectedEvent) {
    this.onChangeCompany.emit(event.option.value);
  }
  onExport() {
    this.onExportClick.emit({ key: 'export', label: 'Export' });
    this.loadExportItems();
  }
  public changeDate(date: any) {
    this.onDateRangeChange.emit({ dates: date });
  }
  public loadExportItems() {
    const data = [];
    if (this.queryResults) {
      for (const row of this.queryResults.items) {
        const temp: any = {};
        for (const colum of this.columns) {
          if (colum.property !== 'actions') {
            temp[colum.label] = row[colum.property] ? row[colum.property] : '';
          }
        }
        data.push(temp);
      }
    }

    this.appSettingsService.exportCSV(data, this.title);
  }

  filterActionButtons(row: any) {
    let filteredActions = this.actions;
    if (row.quotation != 'Yes') {
      filteredActions = filteredActions.filter(
        (item) => item.property !== 'quotationForm'
      );
    }
    return filteredActions;
  }

  filterInnerActionButtons(row: any) {
    let filteredActions = this.innerActions;
    if (row.quotation != 'Yes') {
      filteredActions = filteredActions.filter(
        (item) => item.property !== 'quotationForm'
      );
    }
    return filteredActions;
  }
  filterBurgerActions(row: any): any[] {
    let filteredActions = this.burgerActions;
    if (row.formType !== 'Interactive') {
      filteredActions = filteredActions.filter(
        (action) => action.key !== 'onViewFormFields'
      );
    }
    if (row.isFormVariant) {
      filteredActions = filteredActions.filter(
        (item) => item.key !== 'view' && item.key !== 'download'
      );
    } else {
      filteredActions = filteredActions.filter(
        (item) => item.key !== 'onViewFormVariants'
      );
    }
    if (!row.brandBulkApprove) {
      filteredActions = filteredActions.filter(
        (item) => item.key !== 'approveBrand' && item.key !== 'rejectAllBrand'
      );
    }
    // if (row?.BrandApprove == 'Yes') {
    //   filteredActions = filteredActions.filter(
    //     (item) => item.key !== 'rejectBrand'
    //   );
    // }

    if (row.BrandApprove == 'Pending') {
      filteredActions = filteredActions.filter(
        (item) =>
          item.key !== 'downloadCertificate' &&
          item.key !== 'fileCertificate' &&
          item.key !== 'viewInnerMark' &&
          item.key !== 'downloadInnerMark' &&
          item.key !== 'brandUnpublish' &&
          item.key !== 'brandPublish' &&
          item.key !== 'reactivate' &&
          item.key !== 'terminate' &&
          item.key !== 'modify'
      );
    }
    if (row.BrandApprove == 'No') {
      filteredActions = filteredActions.filter(
        (item) =>
          item.key !== 'downloadCertificate' &&
          item.key !== 'fileCertificate' &&
          item.key !== 'viewInnerMark' &&
          item.key !== 'downloadInnerMark' &&
          item.key !== 'brandUnpublish' &&
          item.key !== 'brandPublish' &&
          item.key !== 'reactivate' &&
          item.key !== 'terminate' &&
          item.key !== 'modify' &&
          item.key !== 'rejectBrand'
      );
    }
    if (row.uploadToWebsite == 'No') {
      filteredActions = filteredActions.filter(
        (item) => item.key !== 'brandUnpublish'
      );
    }
    if (row.uploadToWebsite == 'Yes') {
      filteredActions = filteredActions.filter(
        (item) => item.key !== 'brandPublish'
      );
    }

    if (row.BrandApprove == 'Yes') {
      filteredActions = filteredActions.filter(
        (item) => item.key !== 'reactivate' && item.key !== 'rejectBrand'
      );
    }

    if (row.BrandApprove == 'Terminated') {
      filteredActions = filteredActions.filter(
        (item) =>
          item.key !== 'terminate' &&
          item.key !== 'brandPublish' &&
          item.key !== 'rejectBrand'
      );
    }
    if (
      !row?.multipleFileDownload ||
      (row?.multipleFileDownload && row?.multipleFileDownload?.length == 0)
    ) {
      filteredActions = filteredActions.filter(
        (item) => item.key !== 'multipleFileDownload'
      );
    }
    return filteredActions;
  }
  onActionClick(action: any, data: any) {
    this.onActionClickEmit.emit({ action, data });
  }
  filterBurgerInnerActions(row: any) {
    let filteredActions = this.burgerInnerActions;

    if (row.BrandApprove == 'Pending') {
      filteredActions = filteredActions.filter(
        (item) =>
          item.key !== 'downloadCertificate' &&
          item.key !== 'fileCertificate' &&
          item.key !== 'viewInnerMark' &&
          item.key !== 'downloadInnerMark' &&
          item.key !== 'brandUnpublish' &&
          item.key !== 'brandPublish' &&
          item.key !== 'reactivate' &&
          item.key !== 'terminate' &&
          item.key !== 'modify'
      );
    }
    if (row.BrandApprove == 'No') {
      filteredActions = filteredActions.filter(
        (item) =>
          item.key !== 'downloadCertificate' &&
          item.key !== 'fileCertificate' &&
          item.key !== 'viewInnerMark' &&
          item.key !== 'downloadInnerMark' &&
          item.key !== 'brandUnpublish' &&
          item.key !== 'brandPublish' &&
          item.key !== 'reactivate' &&
          item.key !== 'terminate' &&
          item.key !== 'modify' &&
          item.key !== 'rejectBrand'
      );
    }
    if (row.uploadToWebsite == 'No') {
      filteredActions = filteredActions.filter(
        (item) => item.key !== 'brandUnpublish'
      );
    }
    if (row.uploadToWebsite == 'Yes') {
      filteredActions = filteredActions.filter(
        (item) => item.key !== 'brandPublish'
      );
    }
    if (row.BrandApprove == 'Yes') {
      filteredActions = filteredActions.filter(
        (item) => item.key !== 'reactivate' && item.key !== 'rejectBrand'
      );
    }
    if (row.BrandApprove == 'Terminated') {
      filteredActions = filteredActions.filter(
        (item) =>
          item.key !== 'terminate' &&
          item.key !== 'brandPublish' &&
          item.key !== 'rejectBrand'
      );
    }

    return filteredActions;
  }
  getTextColor(value: any, row = null) {
    let clas = '';
    let isDefault: boolean = false;
    switch (value) {
      case 'Delivered':
      case 'accepted':
      case 'Active':
      case 'Approved':
      case 'Both':
      case 'global':
      case 'Patient':
      case 'Store':
      case 'Adult':
      case 'Amount':
      case 'Yes':
      case 'Metrc':
      case 'Sale':
      case 'Received':
      case 'Close':
      case 'Cash':
      case 'Finalized':
      case 'true':
      case 'Paid':
      case 'Success':
      case 'CQA Admin':
      case 'Completed':
      case 'Informative':
      case 'Complete':
      case 'Published':
        clas = 'text-green-600 bg-green-600/10';
        break;
      case 'Placed':
      case 'created':
      case 'Debit':
      case 'Pay-In':
      case 'Pending':
      case 'Percentage':
      case 'Push Notification':
      case 'PO':
      case 'Moved':
      case 'Fulfillment':
      case 'PaymentInitiated':
      case 'CQA Staff':
      case 'Process':
      case 'Form Submitted':
      case 'Pending Due':
        clas = 'text-yellow-600 bg-yellow-600/10';
        break;
      case 'Credit Card':
      case 'Accepted':
        clas = 'text-[#000AFF] bg-[#E5E6FF]';
        break;
      case 'Wire':
      case 'Agreement Created':
        clas = 'text-[#1796B1] bg-[#E5FAFF]';
        break;
      case 'Company Admin':
      case 'Interactive':
        clas = 'text-blue-600 bg-blue-600/10';
        break;
      case 'ACH':
        clas = 'text-[#FF0099] bg-[#FFE5F4]';
        break;
      case 'Suspended':
        clas = 'text-gray-600 bg-gray-400/10';
        break;
      case 'Shipped':
      case 'Online':
      case 'Medical':
      case 'SMS':
      case 'Consumer':

      case 'Caregiver':
      case 'ExternalPatient':
      case 'Buy One Get One':
      case 'Adjusted':
      case 'Ready For Pickup':
      case 'Tip':
      case 'Credit':

      case 'Manual':
        clas = 'shipped';
        break;
      case 'Cancelled':
      case 'Voided':
      case 'Declined':
      case 'Expired':
      case 'Inactive':
      case 'Pay-Out':
      case 'Open':
      case 'false':
      case 'Destroyed':
      case 'No':
      case 'PastDue':
      case 'Terminated':
      case 'Rejected':
      case 'Failed':
      case 'Unpublished':
      case 'Terminate':
        clas = 'text-red-600 bg-rose-600/10';
        break;
      case 'In transit':
      case 'support':
      case 'Redeemed':
      case 'location':
      case 'POS':
        clas = 'warning';
        break;
      case 'Not Ready For Sale':
        clas = 'not_ready_for_sale';
        break;
      case 'Ready For Sale':
        clas = 'ready_for_sale';
        break;

      case 'Closed':
        clas = 'close_badge';
        break;

      case 'Dispensary Admin':
        clas = 'dispensary_admin';
        break;
      case 'ACH / Wire':
        clas = 'text-[#FF0099] bg-[#FFE5F4]';
        break;
      case '-':
        clas = 'bg-transparent';
        break;
      case 'Manual':
        clas = 'text-blue-600 bg-blue-600/10';
        break;
      case 'Automatic':
        clas = 'text-orange-600 bg-orange-600/10';
        break;
      case 'N/A':
        clas = 'text-gray-600 bg-gray-600/10';
        break;
      default:
        clas = '';
        isDefault = true;
        break;
    }
    if (isDefault) {
      clas = '';
    } else {
      clas = 'badge badge-success' + ' ' + clas;
    }
    return clas;
  }

  getChipColor(value: string, row = null) {
    let clas = '';
    switch (value) {
      case 'Delivered':
      case 'Active':
      case 'Approved':
      case 'Both':
        clas = 'primary';
        break;
      case 'Placed':
      case 'created':
      case 'Pending':
      case 'location':
      case 'global':
      case 'Push Notification':
        clas = 'accent';
        break;
      case 'Shipped':
      case 'SMS':
        clas = 'secondary';
        break;
      case 'Cancelled':

      case 'Declined':
      case 'Inactive':
        clas = 'warn';
        break;
      case 'In transit':
      case 'support':
        clas = 'warn';
        break;
      default:
        break;
    }

    return clas;
  }
  onAddOptionCreate(ev: any) {
    this.onAddOptionClick.emit({ data: ev });
  }
  isActiveStatus(item: any): boolean {
    return this.activeItem === item;
  }
  onClickStatus(item: any) {
    if (this.activeItem === item.value) {
      this.activeItem = item.value;
    } else {
      this.activeItem = item.value;
    }
    this.isLoading = true;
    this.queryResults.items = [];
    this.dataSource = new MatTableDataSource(this.queryResults.items);
    this._cdr.detectChanges();
    this.onBadgeFilterEmit.emit({ dates: item });
  }
  // onDownload(ev: any) {
  //   const fileUrl = ev;

  //   // Create a temporary link element
  //   const link = document.createElement('a');
  //   link.href = fileUrl;
  //   link.download = 'file'; // You can set the desired filename here
  //   document.body.appendChild(link);

  //   // Trigger a click on the link to start the download
  //   link.click();

  //   // Remove the link from the DOM
  //   document.body.removeChild(link);
  // }

  /**
   * Downloads a PDF document and initiates the download process.
   *
   * @param ev - The event object triggered by the download action.
   * @returns void
   */
  async onDownload(ev: any, fileName?: string): Promise<void> {
    const defaultFileName = 'Form.pdf'; // Provide a default name if needed
    fileName = fileName || defaultFileName; // Use the provided name or a default
    // if (!this.userCheck.checkUser()) {
    //   // Get the PDF data (ensure this returns the data you need)
    //   const data = await this.appSettingsService.flattenPdfUrl(ev);
    //   // Create a Blob from the data
    //   const blob = new Blob([data], { type: 'application/pdf' });
    //   // Create a temporary link element
    //   const link = document.createElement('a');
    //   link.href = window.URL.createObjectURL(blob);
    //   link.download = fileName; // Set the desired filename here
    //   document.body.appendChild(link);
    //   // Trigger a click on the link to start the download
    //   link.click();
    //   // Remove the link from the DOM
    //   document.body.removeChild(link);
    //   // Release the object URL
    //   window.URL.revokeObjectURL(link.href);
    // } else {
    const fileUrl = ev;

    // Create a temporary link element
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName; // You can set the desired filename here
    document.body.appendChild(link);

    // Trigger a click on the link to start the download
    link.click();

    // Remove the link from the DOM
    document.body.removeChild(link);
    window.URL.revokeObjectURL(link.href);
    // }
  }
  onBtnAction(ev: any, action: string) {
    this.onBtnActionClick.emit({ data: ev, key: action });
  }

  /**
   * Loads and applies grid column settings for the current user and URL.
   * If no settings are found, it falls back to the default column configuration.
   */
  onLoadGridColumns() {
    // Retrieve existing grid settings from localStorage
    const existingSettings = JSON.parse(
      localStorage.getItem('gridSettings') || '[]'
    );

    // Find settings specific to the current user and URL
    const userSettings = existingSettings.find(
      (entry: any) =>
        entry.userID === this.userDetails?.id && entry.slug === this.router.url
    );

    if (userSettings) {
      // If user-specific settings are found, apply them
      if (this.innerColumns.length > 0) {
        this.innerColumns = userSettings.columns || [];
      } else {
        this.columns = userSettings.columns || [];
      }
    } else {
      // If no user-specific settings are found, use default column configuration
      // this.innerColumns = this.innerColumns;
      // this.innerColumns = this.columns;

      if (this.innerColumns.length > 0) {
        this.innerColumns = this.innerColumns || [];
      } else {
        this.columns = this.columns || [];
      }
    }

    this._cdr.detectChanges();
  }

  /**
   * Reloads the table data by initiating a new data fetch.
   * This method is typically called when the table needs to be refreshed,
   * such as after a data update or when filter criteria change.
   */
  onReloadTable(): void {
    if (this.showStatusBadgeFilter) {
      this.isLoading = true;
      this.queryResults.items = [];
      this.dataSource = new MatTableDataSource(this.queryResults.items);
      this._cdr.detectChanges();
      this.onBadgeFilterEmit.emit({
        dates: { value: this.activeItem }
      });
      return;
    } else {
      // Call initLoadItems with 'true' to indicate it's a fresh load,
      // which may trigger a reset of pagination or other table states
      this.initLoadItems(true);
    }
  }

  /**
   * Checks if the search control has a non-empty value.
   * This method is typically used to determine whether to show a clear search button.
   *
   * @returns {boolean} True if the search control has a non-empty value, false otherwise.
   */
  onShowClearSearch(): boolean {
    const value = this.searchCtrl.value;
    // Check if the value is not an empty string, null, or undefined
    return value !== '' && value !== null && value !== undefined;
  }

  private formatCurrency(value: number | null | undefined): string {
    if (value === null || value === undefined || isNaN(value)) {
      return '';
    }

    // console.log('value-price', value);
    const formattedValue = value.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    });
    // console.log('formattedValue-price', formattedValue);

    return formattedValue.replace('$', ' ');
  }

  onActionColumnClicks(ev: any, key?: string) {
    this.onActionColumnClick.emit({ data: ev, key: key });
  }

  customScrollBar(): void {
    // Update the scrollbar initially
    this.customScrollbarService.updateScrollbar(
      this.scrollContent,
      this.scrollContainer,
      this.scrollBar
    );

    // Listen to the scroll event
    this.scrollContent.nativeElement.addEventListener('scroll', () => {
      this.customScrollbarService.updateScrollbar(
        this.scrollContent,
        this.scrollContainer,
        this.scrollBar
      );
    });

    // Make the scrollbar draggable
    this.customScrollbarService.makeScrollbarDraggable(
      this.scrollContainer,
      this.scrollContent,
      this.scrollBar
    );
  }

  isValidString(value: any): boolean {
    return (
      value !== null &&
      value !== undefined &&
      value !== '' &&
      typeof value == 'string'
    );
  }

  onSetHeightInnerTableAction() {
    // Loop over each row to get its height dynamically
    if (this.rowElements && this.cellElements) {
      this.rowElements.forEach((rowElement, index) => {
        const rowHeight = rowElement.nativeElement.offsetHeight; // Get row height
        // Apply the row height to each corresponding `td` (cell)
        this.cellElements.forEach((cellElement, cellIndex) => {
          if (index === cellIndex) {
            // Match the row and cell index
            this.renderer.setStyle(
              cellElement.nativeElement,
              'height',
              `${rowHeight}px`
            );
          }
        });
      });
    }
  }

  ngOnDestroy() {
    this.loaderService.hideLoader(false); //after destroy change the state Interceptor loader
  }
}
